import { BaseState } from '@/store/base-state';
import { Reports } from '@/modules/reports/types';
import { TableOptions } from '@/types';

export default class ReportsServiceState extends BaseState {
  services: Reports.ServiceActivity[] = [];
  years: number[] = [];
  organizations: Reports.Organization[] | [] = [];
  file = '';
  is_download = false;
  is_download_loading = false;
  loading = false;
  default_quarter = null;
  default_year = null;

  filters: Reports.ServiceReportsFilters = {
    quarter: null,
    year: null,
    organization_ids: [],
  };

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };
}
